var map = {
	"./amnet-loc.jpeg": 95797,
	"./bridge-loc.jpeg": 33499,
	"./daido-loc.jpeg": 38607,
	"./elephant-loc.jpeg": 3791,
	"./gul-irvine-loc.jpeg": 50670,
	"./gul-tor-loc.jpeg": 58856,
	"./tokyo-loc.jpeg": 46442,
	"./torrance-office.jpg": 59157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76854;